import { Component, OnInit, ViewChild } from '@angular/core';
import { CellEditorPrueba } from 'src/app/advantage/config/cell-edit-prueba';
import { AggridsaciComponent } from 'src/app/advantage/aggridsaci/aggridsaci.component';
import { Invencexpmate } from "../invinterfaces/invencexpmate";
import { InvexpmaterialesService } from "../invservicios/invexpmateriales.service";
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { isNullOrUndefined } from 'util';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { Invdetexpmate } from '../invinterfaces/invdetexpmate';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { Trnexpmatmp } from "../invinterfaces/trnexpmatmp";
import { Trnexpmatac } from "../invinterfaces/trnexpmatac";
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';

@Component({
  selector: 'app-invexpmateriales',
  templateUrl: './invexpmateriales.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class InvexpmaterialesComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;

  hmpConfiguracion: any[];
  indicador: any;
  index: number;

  btnNuevo: boolean;
  btnGuardar: boolean;
  btnBorrar: boolean;
  btnRegresar: boolean;
  btnBuscar = true;
  btnExcel: boolean;
  btnPdf: boolean;
  // aggrid
  rowSelection = 'multiple';
  public frameworkComponents;
  rowStyle;
  defaultColDef
  defaultColDefmp
  defaultColDefac
  bolNuevodet: boolean
  largo: string;
  detexpmateSelected: Invdetexpmate;
  detexpmatempSelected: Trnexpmatmp;
  detexpmateacSelected: Trnexpmatac;
  //tabs
  disablebooltabs = true;
  spin = false;
  // busqueda
  opcionbusqueda: string;
  types: SelectItem[];
  arregloCons: any[];
  busquedacampos: string[];
  //
  chkdias: boolean;
  boolfechadesde: boolean;
  tabla: string;
  where: string;
  displayDialogBusquedaFast: boolean;
  //
  booldetexpmate
  //
  strNombreForma: string;
  auxreporte: number = 0;
  displayDialogReportes: boolean;

  columnDefsDetexpmate = [
    { // 0
      headerName: 'Código', field: 'DETEXPMAT_CODIGO', cellEditor: 'cellPrueba',
      editable: (params) => {
        return params.data.DETEXPMAT_NUEVO;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 25,
          opcionbuscar: true
        }
      }
    },
    { // 1
      headerName: 'Nombre', field: 'DETEXPMAT_DESCRIPCION', cellEditor: 'cellPrueba', width: 210,
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 200
        }
      }
    },
    { // 2
      headerName: 'Cobertura', field: 'DETEXPMAT_COBERTURA', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: true,
          tamanocelda: 32,
          tienecalculos: true,
          autorizacion: true
        }
      }
    },
    { // 3
      headerName: 'Venta Total', field: 'DETEXPMAT_VENTATOTAL', cellEditor: 'cellPrueba', width: 110, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: true,
          tamanocelda: 32,
          tienecalculos: true,
          autorizacion: true
        }
      }
    },
    { // 4
      headerName: 'Venta Prom Mensual', field: 'DETEXPMAT_VENPROMMEN', cellEditor: 'cellPrueba', width: 165, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: true,
          tamanocelda: 32,
          tienecalculos: true,
          autorizacion: true
        }
      }
    },
    { // 5
      headerName: 'Inv. Real', field: 'DETEXPMAT_INVREAL', cellEditor: 'cellPrueba', width: 110, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: true,
          tamanocelda: 32,
          tienecalculos: true,
          autorizacion: true
        }
      }
    },
    { // 6
      headerName: 'Unidades Pendientes', field: 'DETEXPMAT_UNDPENDIENTES', cellEditor: 'cellPrueba', width: 165, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: true,
          tamanocelda: 32,
          tienecalculos: true,
          autorizacion: true
        }
      }
    },
    { // 7
      headerName: 'Cant. Sugerida(PT)', field: 'DETEXPMAT_CANTSUGEPT', cellEditor: 'cellPrueba', width: 165, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return this.booldetexpmate;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
    { // 8
      headerName: 'Cant. Sugerida(KG)', field: 'DETEXPMAT_CANTSUGEKG', cellEditor: 'cellPrueba', width: 165, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return this.booldetexpmate;
      },

      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
  ]
  columnDefsDetexpmateMP = [
    { // 0
      headerName: 'Código', field: 'EXPMATMP_CODIGO', cellEditor: 'cellPrueba',
      editable: (params) => {
        return params.data.NUEVOL;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 25,
          opcionbuscar: true
        }
      }
    },
    { // 1
      headerName: 'Nombre', field: 'EXPMATMP_DESCRIPCION', cellEditor: 'cellPrueba', width: 210,
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 200
        }
      }
    },
    { // 2
      headerName: 'Cant. Sugerida(KG)', field: 'EXPMATMP_CANTSUGKG', cellEditor: 'cellPrueba', width: 165, cellStyle: { textAlign: 'right' },
      editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
  ]
  columnDefsDetexpmateAC = [
    { // 0
      headerName: 'Código', field: 'TRNEXPMATAC_CODIGO', cellEditor: 'cellPrueba',
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 25,
          opcionbuscar: true
        }
      }
    },
    { // 1
      headerName: 'Nombre', field: 'TRNEXPMATAC_DESCRIPCION', cellEditor: 'cellPrueba', width: 210,
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 200
        }
      }
    },
    { // 2
      headerName: 'Cant. Sugerida(PT)', field: 'TRNEXPMATAC_CANTSUGUND', cellEditor: 'cellPrueba', width: 165, cellStyle: { textAlign: 'right' },
      editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 32,
          tienecalculos: true
        }
      }
    },
  ]
  constructor(public invexpmaterialesService: InvexpmaterialesService,
    public init: NuevoComponentService, private messageService: MessageService, private datePipe: DatePipe, private auditoriagral: AuditoriagralService,
    private busqService: InvbusquedaService,
    private confirmationService: ConfirmationService, private confIniciales: ConfInicialesService,

  ) {
    this.agTable();

  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };

    this.defaultColDef = {
      editable: true,
      width: 100,
      objeto: 'detexpmate',
      resizable: true
    };
    this.defaultColDefmp = {
      editable: true,
      width: 100,
      objeto: 'detexpmatemp',
      resizable: true
    };
    this.defaultColDefac = {
      editable: true,
      width: 100,
      objeto: 'detexpmateac',
      resizable: true
    };
  }

  ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.index = 0;
    this.largo = '-2800';
    this.invexpmaterialesService.encexpmate[this.indicador] = {}
    this.invexpmaterialesService.detexpmatearray[this.indicador] = []
    this.detexpmateSelected = {}
    this.detexpmateacSelected = {}
    this.detexpmatempSelected = {}
    this.bolNuevodet = true;
    this.chkdias = false;
    this.boolfechadesde = true;
    this.habilitarBotonesBarra(false, true, false, false, false);
    this.decimales();
    this.getconfiguracion()
    setTimeout(() => {
      this.aggrid.refreshColumnDefsIndice(this.indicador, this.defaultColDef.objeto, this.columnDefsDetexpmate);
      this.aggrid.refreshColumnDefsIndice(this.indicador, this.defaultColDefmp.objeto, this.columnDefsDetexpmateMP);
      this.aggrid.refreshColumnDefsIndice(this.indicador, this.defaultColDefac.objeto, this.columnDefsDetexpmateAC);

    }, 2000);
  }

  manejarSenales(valor) {
    if (valor === 'Nuevo') {
      this.irnuevo()
    }
    if (valor === 'Cancelar') {
      this.cancelar()
    }

    if (valor === 'Visto') {
      if (this.index === 0
        && (isNullOrUndefined(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO) === false
          || this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO)
      ) {
        this.procesarCobertura()
      }

    }
    if (valor === 'Guardar') {
      this.validaguardar();
    }
    if (valor === 'Borrar') {
      if (this.index === 0) {
        if (this.booldetexpmate === true) {
          this.borrarCobertura();
        } else {
          this.messageService.add({
            key: 'invexpmate',
            severity: 'error',
            summary: 'Explosión',
            detail: 'Elimine la información de las pestañas Explosion de materiales MP y Explosion de materiales AC'
          });
        }

      }
      if (this.index === 1) {
        this.borrarmaterialesMp();
      }
      if (this.index === 2) {
        this.borrarmaterialesAc();
      }
    }
    if (valor === 'Buscar') {
      this.buscar();
    }
    if (valor === 'Imprimir') {
      if (this.index === 0) {
        this.strNombreForma = 'frmINV_EXPMATERIALES';
      } else if (this.index === 1) {
        this.strNombreForma = 'frmINV_EXPMATERIALESMP';
      } else if (this.index === 2) {
        this.strNombreForma = 'frmINV_EXPMATERIALESAC';
      }

      this.auxreporte++;
      this.displayDialogReportes = true;
    }
    if (valor === 'Salir') {
      // this.encfacService.ACTPRUEBA().subscribe();
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  borrarmaterialesMp() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar los materiales MP ',
      header: 'Eliminar Cobertura',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmarinvexpmate',
      accept: async () => {
        try {
          await this.invexpmaterialesService.eliminarMP(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO)
          await this.auditoriagral.registrarAuditoria('INV_TRNEXPMATMP',
            this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO, 'E', '', '01', '', '', '', '').toPromise();
          this.confirmationService.close();
          this.messageService.add({
            key: 'invexpmate',
            severity: 'success',
            summary: 'Explosión',
            detail: 'Los materiales MP se eliminaron con éxito '
          });
          this.invexpmaterialesService.trnexpmatmp = []
          this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatmp, this.defaultColDefmp.objeto)
          this.booldetexpmate = true
        } catch (error) {
          this.messageService.add({
            key: 'invexpmate',
            severity: 'error',
            summary: 'Explosión',
            detail: 'Ocurrió un error al eliminar los materiales MP ' + error
          });
          this.spin = false
        }


      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  getconfiguracion() {
    this.auditoriagral.obtenerConfiguracion1().subscribe((conf) => {
      this.hmpConfiguracion = conf;
      this.invexpmaterialesService.hmpConfiguracion = conf;
    })
  }
  borrarmaterialesAc() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar los materiales AC ',
      header: 'Eliminar Cobertura',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmarinvexpmate',
      accept: async () => {
        try {
          await this.invexpmaterialesService.eliminarAC(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO)
          await this.auditoriagral.registrarAuditoria('INV_TRNEXPMATAC',
            this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO, 'E', '', '01', '', '', '', '').toPromise();
          this.confirmationService.close();
          this.messageService.add({
            key: 'invexpmate',
            severity: 'success',
            summary: 'Explosión',
            detail: 'Los materiales AC se eliminaron con éxito '
          });
          this.invexpmaterialesService.trnexpmatac = []
          this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatac, this.defaultColDefac.objeto)
          this.booldetexpmate = true
        } catch (error) {
          this.messageService.add({
            key: 'invexpmate',
            severity: 'error',
            summary: 'Explosión',
            detail: 'Ocurrió un error al eliminar los materiales AC ' + error
          });
          this.spin = false
        }


      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async decimales() {
    this.confIniciales.getDecimales('frmINV_MAEARTICULO').subscribe((dec) => {
      if (dec !== null) {
        dec.map((decimales) => {
          if (decimales.NUMDEC_CAMPO === 'CANTIDAD') {
            this.invexpmaterialesService.decimalesCantidadart = Number(decimales.NUMDEC_NUMDEC);
          }
        })
        this.columnDefsDetexpmate[7].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.invexpmaterialesService.decimalesCantidadart,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 32,
            tienecalculos: true
          }
        };
        this.columnDefsDetexpmate[8].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.invexpmaterialesService.decimalesCantidadart,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 32,
            tienecalculos: true
          }
        };
        this.columnDefsDetexpmateMP[2].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.invexpmaterialesService.decimalesCantidadart,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 32,
            tienecalculos: true
          }
        };
        this.columnDefsDetexpmateAC[2].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.invexpmaterialesService.decimalesCantidadart,
            obligatorio: true,
            fecha: false,
            clave: false,
            tamanocelda: 32,
            tienecalculos: true
          }
        };
      }
    })
  }
  buscar() {
    this.opcionbusqueda = 'cobertura';
    this.types = [
      { label: 'Código', value: 'ENCEXPMAT_CODIGO' },
      { label: 'Cobertura', value: 'ENCEXPMAT_COBERTURA' },
      { label: 'Fecha_inicio', value: 'ENCEXPMAT_FECHAINI' },
      { label: 'Fecha_final', value: 'ENCEXPMAT_FECHAFIN' },
      { label: 'Periodo', value: 'ENCEXPMAT_PERIODO' },

    ];
    this.busquedacampos = ['', '', '', '', '', '', '', '', '', ''];
    this.tabla = 'INV_ENCEXPMAT';
    this.where = 'ENCEXPMAT_CODIGO is not null order by ENCEXPMAT_CODIGO desc';

    //this.spin = true;
    this.busqService.busquedaInvEncExpmate().subscribe((datos: any[]) => {
      this.arregloCons = datos;
      if (this.arregloCons.length > 0 && this.arregloCons !== null) {
        this.arregloCons.map((registro) => {
          if (registro.ENCEXPMAT_FECHAINI !== null) {
            registro.ENCEXPMAT_FECHAINI = this.datePipe.transform(registro.ENCEXPMAT_FECHAINI, 'dd/MM/yyyy');
          } else {
            registro.ENCEXPMAT_FECHAINI = '';
          }
          if (registro.ENCEXPMAT_FECHAFIN !== null) {
            registro.ENCEXPMAT_FECHAFIN = this.datePipe.transform(registro.ENCEXPMAT_FECHAFIN, 'dd/MM/yyyy');
          } else {
            registro.ENCEXPMAT_FECHAFIN = '';
          }
        });
      }

      //this.spin = false;
      this.displayDialogBusquedaFast = true;
    });
  }
  async borrarCobertura() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar la cobertura ',
      header: 'Eliminar Cobertura',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmarinvexpmate',
      accept: async () => {
        await this.invexpmaterialesService.eliminarcobertura(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO)
        await this.auditoriagral.registrarAuditoria('INV_ENCEXPMAT',
          this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO, 'E', '', '01', '', '', '', '').toPromise();
        this.confirmationService.close();
        this.messageService.add({
          key: 'invexpmate',
          severity: 'success',
          summary: 'Explosión',
          detail: 'La cobertura se eliminó con éxito '
        });
        this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO = ''
        await this.cancelar();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async validaguardar() {
    const item = this.invexpmaterialesService.encexpmate[this.indicador]
    this.spin = true;
    if (isNullOrUndefined(item.ENCEXPMAT_FECHAFIN) || item.ENCEXPMAT_FECHAFIN === '') {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Error',
        detail: 'La fecha fin no puede estar vacía'
      });
      this.spin = false;
      return;
    }
    if (isNullOrUndefined(item.ENCEXPMAT_FECHAINI) || item.ENCEXPMAT_FECHAINI === '') {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Error',
        detail: 'La fecha de inicio no puede estar vacía'
      });
      this.spin = false;
      return;
    }
    if (isNullOrUndefined(item.ENCEXPMAT_PERIODO) || item.ENCEXPMAT_PERIODO === '') {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Error',
        detail: 'El periodo no puede estar vacío'
      });
      this.spin = false;
      return;
    }
    if (isNullOrUndefined(item.ENCEXPMAT_COBERTURA) || item.ENCEXPMAT_COBERTURA === '') {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Error',
        detail: 'La cobertura no puede estar vacía'
      });
      this.spin = false;
      return;
    }
    if (this.invexpmaterialesService.detexpmatearray[this.indicador].length === 0) {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Error',
        detail: 'El detalle de la cobertura no puede estar vacía'
      });
      this.spin = false;
      return;
    }
    for (const iterator of this.invexpmaterialesService.detexpmatearray[this.indicador]) {
      if (isNullOrUndefined(iterator.DETEXPMAT_CODIGO) || iterator.DETEXPMAT_CODIGO === '') {
        this.messageService.add({
          key: 'invexpmate',
          severity: 'error',
          summary: 'Error',
          detail: 'El código no puede estar vacío'
        });
        this.spin = false;
        return;
      }
      if (isNullOrUndefined(iterator.DETEXPMAT_CANTSUGEPT) || iterator.DETEXPMAT_CANTSUGEPT === '') {
        this.messageService.add({
          key: 'invexpmate',
          severity: 'error',
          summary: 'Error',
          detail: 'La cantidad sugerida PT no puede estar vacía'
        });
        this.spin = false;
        return;
      }
      if (isNullOrUndefined(iterator.DETEXPMAT_CANTSUGEKG) || iterator.DETEXPMAT_CANTSUGEKG === '') {
        this.messageService.add({
          key: 'invexpmate',
          severity: 'error',
          summary: 'Error',
          detail: 'La cantidad sugerida KG no puede estar vacía'
        });
        this.spin = false;
        return;
      }

    }
    await this.guardar();
  }
  async guardar() {
    const item = this.invexpmaterialesService.encexpmate[this.indicador]
    try {
      if (item.ENCEXPMAT_FECHAFIN.toString().includes('-')) {
        item.ENCEXPMAT_FECHAFIN = this.datePipe.transform(item.ENCEXPMAT_FECHAFIN, 'dd/MM/yyyy')
      }
      if (item.ENCEXPMAT_FECHAINI.toString().includes('-')) {
        item.ENCEXPMAT_FECHAINI = this.datePipe.transform(item.ENCEXPMAT_FECHAINI, 'dd/MM/yyyy')
      }
      const data = await this.invexpmaterialesService.insertarencexpmate(item);

      if (data.length > 0 && data !== null) {

        for (const iterator of data) {
          let expmatecod = this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO
          if (isNullOrUndefined(expmatecod) || expmatecod === '') {
            await this.auditoriagral.registrarAuditoria('INV_ENCEXPMAT',
              iterator.ENCEXPMAT_CODIGO, 'I', '', '01', '', '', '', '').toPromise();
          } else {
            await this.auditoriagral.registrarAuditoria('INV_ENCEXPMAT',
              iterator.ENCEXPMAT_CODIGO, 'A', '', '01', '', '', '', '').toPromise();
          }
          this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO = iterator.ENCEXPMAT_CODIGO
          expmatecod = this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO
          for (const iterator2 of this.invexpmaterialesService.detexpmatearray[this.indicador]) {
            iterator2.ENCEXPMAT_CODIGO = expmatecod;
            await this.invexpmaterialesService.insertardetexpmate(iterator2)
            if (iterator2.DETEXPMAT_NUEVOL === true) {
              await this.auditoriagral.registrarAuditoria('INV_DETEXPMAT', expmatecod + '/' + iterator2.DETEXPMAT_CODIGO, 'I', '', '01', '', '', '', '').toPromise();
            } else {
              await this.auditoriagral.registrarAuditoria('INV_DETEXPMAT', expmatecod + '/' + iterator2.DETEXPMAT_CODIGO, 'A', '', '01', '', '', '', '').toPromise();
            }

          }
          this.disablebooltabs = false;
        }
        this.messageService.add({
          key: 'invexpmate',
          severity: 'success',
          summary: 'Explosión',
          detail: 'La cobertura se guardó con éxito '
        });
        await this.cancelar();
        this.spin = false;
      }
    } catch (error) {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al guardar la cobertura'
      });
      console.log(error)
      this.spin = false;
    }

  }
  async procesarCobertura() {
    try {
      const item = this.invexpmaterialesService.encexpmate[this.indicador]

      let itemdet: Invdetexpmate[] = []
      this.spin = true;
      if (isNullOrUndefined(item.ENCEXPMAT_FECHAFIN) || item.ENCEXPMAT_FECHAFIN === '') {
        this.messageService.add({
          key: 'invexpmate',
          severity: 'error',
          summary: 'Error',
          detail: 'La fecha fin no puede estar vacía'
        });
        this.spin = false;
        return;
      }
      if (isNullOrUndefined(item.ENCEXPMAT_FECHAINI) || item.ENCEXPMAT_FECHAINI === '') {
        this.messageService.add({
          key: 'invexpmate',
          severity: 'error',
          summary: 'Error',
          detail: 'La fecha de inicio no puede estar vacía'
        });
        this.spin = false;
        return;
      }
      if (isNullOrUndefined(item.ENCEXPMAT_PERIODO) || item.ENCEXPMAT_PERIODO === '') {
        this.messageService.add({
          key: 'invexpmate',
          severity: 'error',
          summary: 'Error',
          detail: 'El periodo no puede estar vacío'
        });
        this.spin = false;
        return;
      }
      if (isNullOrUndefined(item.ENCEXPMAT_COBERTURA) || item.ENCEXPMAT_COBERTURA === '') {
        this.messageService.add({
          key: 'invexpmate',
          severity: 'error',
          summary: 'Error',
          detail: 'La cobertura no puede estar vacía'
        });
        this.spin = false
        return;
      }
      if (item.ENCEXPMAT_FECHAFIN.toString().includes('-')) {
        item.ENCEXPMAT_FECHAFIN = this.datePipe.transform(item.ENCEXPMAT_FECHAFIN, 'dd/MM/yyyy')
      }
      if (item.ENCEXPMAT_FECHAINI.toString().includes('-')) {
        item.ENCEXPMAT_FECHAINI = this.datePipe.transform(item.ENCEXPMAT_FECHAINI, 'dd/MM/yyyy')
      }
      const data = await this.invexpmaterialesService.procesarcobertura(item)
      if (data !== null) {
        if (data.length > 0) {
          let i = 0
          for (const iterator of data) {
            let itemdetarray: Invdetexpmate = {}
            itemdetarray.DETEXPMAT_CODIGO = iterator.ART_CODIGO,
              itemdetarray.DETEXPMAT_DESCRIPCION = iterator.ART_NOMBRE,
              itemdetarray.DETEXPMAT_COBERTURA = Number(iterator.TRNEXP_COVERTURA).toFixed(2),
              itemdetarray.DETEXPMAT_VENTATOTAL = Number(iterator.TRNEXP_VENTOTAL).toFixed(2),
              itemdetarray.DETEXPMAT_VENPROMMEN = Number(iterator.TRNEXP_VENPROMMEN).toFixed(2),
              itemdetarray.DETEXPMAT_INVREAL = Number(iterator.TRNEXP_INVREAL).toFixed(2),
              itemdetarray.DETEXPMAT_UNDPENDIENTES = Number(iterator.TRNEXP_UNIPEND).toFixed(2),
              itemdetarray.DETEXPMAT_CANTSUGEPT = Number(iterator.TRNEXP_CANSUGUND).toFixed(this.invexpmaterialesService.decimalesCantidadart)
            itemdetarray.DETEXPMAT_CANTSUGEKG = Number(iterator.TRNEXP_CANSUGKG).toFixed(this.invexpmaterialesService.decimalesCantidadart)
            itemdetarray.DETEXPMAT_NUEVO = false
            itemdetarray.DETEXPMAT_LINEA = i
            itemdetarray.DETEXPMAT_NUEVOL = true;
            itemdet.push(itemdetarray)
            this.detexpmateSelected = itemdetarray
            i++;
          }
          this.invexpmaterialesService.detexpmatearray[this.indicador] = itemdet
        }

      } else {
        this.messageService.add({
          key: 'invexpmate',
          severity: 'error',
          summary: 'Error',
          detail: 'no existe información en el periodo seleccionado '
        });
        this.spin = false;
        this.bolNuevodet = false;
        return;
      }
      this.spin = false;
      this.bolNuevodet = false;
    } catch (error) {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al procesar la cobertura ' + error
      });
      this.spin = false;
      this.bolNuevodet = true;
      return;

    }
  }
  irnuevo() {
    this.index = 0
    this.invexpmaterialesService.encexpmate[this.indicador] = {}
    this.invexpmaterialesService.detexpmatearray[this.indicador] = []
    this.invexpmaterialesService.encexpmate[this.indicador] = {
      ENCEXPMAT_CODIGO: '',
      ENCEXPMAT_COBERTURA: '',
      ENCEXPMAT_FECHAINI: '',
      ENCEXPMAT_FECHAFIN: new Date(),
      ENCEXPMAT_PERIODO: ''
    }
    this.disablebooltabs = true;
    this.chkdias = false;
    this.boolfechadesde = true;
    this.habilitarBotonesBarra(true, false, false, false, false);
    document.getElementById('ENCEXPMAT_COBERTURA').focus();
    document.getElementById('contorno').style.pointerEvents = 'all';
    this.booldetexpmate = true
    //document.getElementById('contorno2').style.pointerEvents = 'all';
  }
  habilitarBotonesBarra(nuevo, guardar, eliminar, excel, pdf) {
    this.btnNuevo = nuevo;
    this.btnBorrar = eliminar;
    this.btnGuardar = guardar;
    this.btnExcel = excel;
    this.btnPdf = pdf;
  }
  cancelar() {
    let codigo = this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO
    if (codigo === null || codigo === undefined || codigo === '') {
      this.invexpmaterialesService.encexpmate[this.indicador] = {}
      this.invexpmaterialesService.detexpmatearray[this.indicador] = []
      this.disablebooltabs = true;
      this.chkdias = false;
      this.boolfechadesde = true;
      this.booldetexpmate = false
      this.habilitarBotonesBarra(false, true, false, false, false);
      document.getElementById('contorno').style.pointerEvents = 'none';
    } else {
      this.mostrarDatos(codigo)
      document.getElementById('contorno').style.pointerEvents = 'none';
    }
  }
  manejarSeleccion(opcion) {
    if (this.opcionbusqueda === 'cobertura') {
      this.mostrarDatos(opcion.ENCEXPMAT_CODIGO);
    }
    this.displayDialogBusquedaFast = false
  }
  async mostrarDatos(codigo) {
    try {
      this.invexpmaterialesService.encexpmate[this.indicador] = {}
      this.invexpmaterialesService.detexpmatearray[this.indicador] = []
      this.spin = true;
      this.bolNuevodet = false;
      const data = await this.invexpmaterialesService.consultarencexpmate(codigo);
      const data2 = await this.invexpmaterialesService.consultardetexpmate(codigo);
      const rs1 = await this.invexpmaterialesService.consultartrnexpmatmp(codigo);
      const rs3 = await this.invexpmaterialesService.consultartrnexpmatac(codigo);
      if (rs1.length !== 0 && rs1 !== null) {
        let id = 0
        for (const iterator of rs1) {
          iterator.EXPMATMP_CANTSUGKG = Number(iterator.EXPMATMP_CANTSUGKG).toFixed(this.invexpmaterialesService.decimalesCantidadart)
          iterator.NUEVO = false
          iterator.NUEVOL = false
          iterator.LINEA = id
          id++
        }
        this.invexpmaterialesService.trnexpmatmp = rs1
        this.booldetexpmate = false
        this.bolNuevodet = true;
        //document.getElementById('contorno2').style.pointerEvents = 'none';
      } else {
        this.booldetexpmate = true
      }
      if (rs3.length !== 0 && rs3 !== null) {
        let id = 0
        for (const iterator of rs3) {
          iterator.TRNEXPMATAC_CANTSUGUND = Number(iterator.TRNEXPMATAC_CANTSUGUND).toFixed(this.invexpmaterialesService.decimalesCantidadart)
          iterator.NUEVO = false
          iterator.NUEVOL = false
          iterator.LINEA = id
          id++
        }
        this.invexpmaterialesService.trnexpmatac = rs1
        this.booldetexpmate = false
        this.bolNuevodet = true;
        //document.getElementById('contorno2').style.pointerEvents = 'none';
      } else {
        this.booldetexpmate = true
      }

      if (data.length > 0 && data !== null) {
        for (const item of data) {
          if (item.ENCEXPMAT_FECHAFIN.toString().includes('-')) {
            item.ENCEXPMAT_FECHAFIN = this.datePipe.transform(item.ENCEXPMAT_FECHAFIN, 'dd/MM/yyyy')
          }
          if (item.ENCEXPMAT_FECHAINI.toString().includes('-')) {
            item.ENCEXPMAT_FECHAINI = this.datePipe.transform(item.ENCEXPMAT_FECHAINI, 'dd/MM/yyyy')
          }
          item.ENCEXPMAT_PERIODO = Number(item.ENCEXPMAT_PERIODO).toFixed(2);
          this.invexpmaterialesService.encexpmate[this.indicador] = item
        }
      }
      if (data2.length > 0 && data2 !== null) {
        let i = 0
        for (const iterator of data2) {
          iterator.DETEXPMAT_VENTATOTAL = Number(iterator.DETEXPMAT_VENTATOTAL).toFixed(2),
            iterator.DETEXPMAT_VENPROMMEN = Number(iterator.DETEXPMAT_VENPROMMEN).toFixed(2),
            iterator.DETEXPMAT_CANTSUGEPT = Number(iterator.DETEXPMAT_CANTSUGEPT).toFixed(this.invexpmaterialesService.decimalesCantidadart)
          iterator.DETEXPMAT_CANTSUGEKG = Number(iterator.DETEXPMAT_CANTSUGEKG).toFixed(this.invexpmaterialesService.decimalesCantidadart)
          iterator.DETEXPMAT_COBERTURA = Number(iterator.DETEXPMAT_COBERTURA).toFixed(2)
          iterator.DETEXPMAT_INVREAL = Number(iterator.DETEXPMAT_INVREAL).toFixed(2)
          iterator.DETEXPMAT_UNDPENDIENTES = Number(iterator.DETEXPMAT_UNDPENDIENTES).toFixed(2)
          iterator.DETEXPMAT_NUEVO = false
          iterator.DETEXPMAT_LINEA = i
          iterator.DETEXPMAT_NUEVOL = false
          this.detexpmateSelected = iterator
          i++;
        }
        this.invexpmaterialesService.detexpmatearray[this.indicador] = data2;

      }
      this.habilitarBotonesBarra(false, true, false, true, true);
      this.spin = false;
      this.disablebooltabs = false;
      //this.bolNuevodet = true
    } catch (error) {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Error',
        detail: 'Ocurrió un error al consultar la cobertura ' + error
      });
      this.spin = false
    }
  }
  botonesmodificar() {
    this.btnNuevo = true;
    this.btnBorrar = true;
    this.btnGuardar = false;
    this.btnExcel = false;
    this.btnPdf = false;
  }
  calfechadesde() {
    const dateTimeFecIni: Date = this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_FECHAFIN;
    this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_FECHAINI = this.obtenerFechaIni(dateTimeFecIni.getDate(),
      dateTimeFecIni.getMonth(), dateTimeFecIni.getFullYear());

  }
  obtenerFechaIni(dia, mes, anio): Date {
    let fecha1: Date;
    fecha1 = new Date(anio, mes, dia);
    let periodoStr = this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_PERIODO
    let periodo = periodoStr === '' ? 0 : Number(periodoStr)
    fecha1.setMonth(fecha1.getMonth() - periodo);

    return fecha1;
  }
  async changeTabs() {
    if (this.index === 0) {
      this.habilitarBotonesBarra(false, true, false, false, false);
    }
    if (this.index === 1) {
      this.habilitarBotonesBarra(true, true, false, false, false);
      let id = 0
      const rs1 = await this.invexpmaterialesService.consultartrnexpmatmp(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO);
      const rs2 = await this.invexpmaterialesService.consultartrnexpmatmpini(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO);
      if (rs1.length !== 0 && rs1 !== null) {
        for (const iterator of rs1) {
          iterator.EXPMATMP_CANTSUGKG = Number(iterator.EXPMATMP_CANTSUGKG).toFixed(this.invexpmaterialesService.decimalesCantidadart)
          iterator.NUEVO = false
          iterator.NUEVOL = false;
          iterator.LINEA = id
          id++
        }
        this.invexpmaterialesService.trnexpmatmp = rs1
        this.booldetexpmate = false
        //document.getElementById('contorno2').style.pointerEvents = 'none';
      } else if (rs2.length !== 0 && rs2 !== null) {
        let itemdet: Trnexpmatmp[] = []
        for (const iterator of rs2) {
          let itemdetarray: Trnexpmatmp = {}
          itemdetarray.ENCEXPMAT_CODIGO = this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO
          itemdetarray.EXPMATMP_CODIGO = iterator.ART_CODIGOP
          itemdetarray.EXPMATMP_DESCRIPCION = iterator.DETEXPMAT_DESCRIPCION
          itemdetarray.EXPMATMP_CANTSUGKG = Number(iterator.DETEXPMAT_CANTSUGEKG).toFixed(this.invexpmaterialesService.decimalesCantidadart)
          //itemdetarray.ART_CODIGO = iterator.ART_CODIGO
          itemdetarray.NUEVO = true
          itemdetarray.NUEVOL = true
          itemdetarray.LINEA = id
          id++
          itemdet.push(itemdetarray)
        }
        this.booldetexpmate = true
        this.invexpmaterialesService.trnexpmatmp = itemdet
        this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatmp, this.defaultColDefmp.objeto);
      } else {
        this.messageService.add({
          key: 'invexpmate',
          severity: 'error',
          summary: 'Error',
          detail: 'no existe información(MP) en el periodo seleccionado '
        });
        this.spin = false;
        return;
      }

    }
    if (this.index === 2) {
      this.habilitarBotonesBarra(true, true, false, false, false);
      let id = 0
      const rs1 = await this.invexpmaterialesService.consultartrnexpmatac(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO);
      const rs2 = await this.invexpmaterialesService.consultartrnexpmatacini(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO);
      if (rs1.length !== 0 && rs1 !== null) {
        for (const iterator of rs1) {
          iterator.TRNEXPMATAC_CANTSUGUND = Number(iterator.TRNEXPMATAC_CANTSUGUND).toFixed(this.invexpmaterialesService.decimalesCantidadart)
          iterator.NUEVO = false
          iterator.NUEVOL = false;
          iterator.LINEA = id
          id++
        }
        this.invexpmaterialesService.trnexpmatac = rs1
        this.booldetexpmate = false
        //document.getElementById('contorno2').style.pointerEvents = 'none';
      } else if (rs2.length !== 0 && rs2 !== null) {
        let itemdet: Trnexpmatac[] = []
        for (const iterator of rs2) {
          let itemdetarray: Trnexpmatac = {}
          itemdetarray.ENCEXPMAT_CODIGO = this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO
          itemdetarray.TRNEXPMATAC_CODIGO = iterator.DETEXPMAT_CODIGO
          itemdetarray.TRNEXPMATAC_DESCRIPCION = iterator.DETEXPMAT_DESCRIPCION
          itemdetarray.TRNEXPMATAC_CANTSUGUND = Number(iterator.DETEXPMAT_CANTSUGEPT).toFixed(this.invexpmaterialesService.decimalesCantidadart)
          //itemdetarray.ART_CODIGO = iterator.ART_CODIGO
          itemdetarray.NUEVO = true
          itemdetarray.NUEVOL = true
          itemdetarray.LINEA = id
          id++
          itemdet.push(itemdetarray)
        }
        this.booldetexpmate = true
        this.invexpmaterialesService.trnexpmatac = itemdet
        this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatac, this.defaultColDefac.objeto);
      } else {
        this.messageService.add({
          key: 'invexpmate',
          severity: 'error',
          summary: 'Error',
          detail: 'no existe información(AC) en el periodo seleccionado '
        });
        this.spin = false;
        return;
      }
    }
  }
  setFocus(event) {
    let element: any;
    switch (event.target.id) {
      case 'ENCEXPMAT_COBERTURA': {
        element = document.getElementById('ENCEXPMAT_PERIODO');
        break;
      }
      default: {
        break;
      }
    }
    if (element === null || element === undefined) {
      return;
    } else {
      element.focus();
    }
  }
  selecciondetexpmate(params) {
    if (this.booldetexpmate === false) {
      return
    }
    if (params === 'nuevo') {
      //this.bolNuevodet = true;
      this.nuevodetalle();
      return;
    }
    if (params === 'eliminar') {
      // this.bolNuevodet = false;
      this.eliminarLineaDetalle();
      return;
    }
    if (params.object !== undefined) {
      this.detexpmateSelected = params.object;
    }
  }
  nuevodetalle() {

    const indi = this.invexpmaterialesService.detexpmatearray[this.indicador].indexOf(this.detexpmateSelected);
    const detexpmate: Invdetexpmate = {
      ENCEXPMAT_CODIGO: '',
      DETEXPMAT_CODIGO: '',
      DETEXPMAT_DESCRIPCION: '',
      DETEXPMAT_COBERTURA: Number(0).toFixed(2),
      DETEXPMAT_VENTATOTAL: Number(0).toFixed(2),
      DETEXPMAT_VENPROMMEN: Number(0).toFixed(2),
      DETEXPMAT_INVREAL: Number(0).toFixed(2),
      DETEXPMAT_UNDPENDIENTES: Number(0).toFixed(2),
      DETEXPMAT_CANTSUGEPT: Number(0).toFixed(this.invexpmaterialesService.decimalesCantidadart),
      DETEXPMAT_CANTSUGEKG: Number(0).toFixed(this.invexpmaterialesService.decimalesCantidadart),
      DETEXPMAT_NUEVO: true,
      DETEXPMAT_NUEVOL: true,
      DETEXPMAT_LINEA: this.invexpmaterialesService.detexpmatearray[this.indicador].length + 1
    };
    this.invexpmaterialesService.detexpmatearray[this.indicador].splice(indi + 1, 0, detexpmate);
    this.detexpmateSelected = detexpmate;
    this.aggrid.refreshaggridindex(this.invexpmaterialesService.detexpmatearray[this.indicador], this.defaultColDef.objeto, indi);

  }
  async eliminarLineaDetalle() {
    try {
      const indi = this.invexpmaterialesService.detexpmatearray[this.indicador].indexOf(this.detexpmateSelected);
      if (this.detexpmateSelected.DETEXPMAT_NUEVOL === true) {
        this.invexpmaterialesService.detexpmatearray[this.indicador].splice(this.invexpmaterialesService.detexpmatearray[this.indicador].findIndex(
          detfac => detfac.DETEXPMAT_LINEA === this.detexpmateSelected.DETEXPMAT_LINEA),
          1);
        this.aggrid.refreshaggrid(this.invexpmaterialesService.detexpmatearray[this.indicador], this.defaultColDef.objeto);
      } else {
        await this.invexpmaterialesService.eliminarlineadet(this.detexpmateSelected)
        await this.auditoriagral.registrarAuditoria('INV_DETEXPMAT',
          this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO + '/' + this.detexpmateSelected.DETEXPMAT_CODIGO + '/' + this.detexpmateSelected.DETEXPMAT_CANTSUGEKG, 'E', '', '01', '', '', '', '').toPromise();
        this.invexpmaterialesService.detexpmatearray[this.indicador].splice(this.invexpmaterialesService.detexpmatearray[this.indicador].findIndex(
          detfac => detfac.DETEXPMAT_LINEA === this.detexpmateSelected.DETEXPMAT_LINEA),
          1);
        this.aggrid.refreshaggrid(this.invexpmaterialesService.detexpmatearray[this.indicador], this.defaultColDef.objeto);
      }

      this.messageService.add({
        key: 'invexpmate',
        severity: 'success',
        summary: 'Explosión',
        detail: 'El registro se eliminó con éxito '
      });

      if (this.invexpmaterialesService.detexpmatearray[this.indicador].length > 0) {
        if (indi === 0) {
          this.detexpmateSelected = this.invexpmaterialesService.detexpmatearray[this.indicador][indi];

          this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
            this.defaultColDef.objeto].setFocusedCell((indi), 'DETEXPMAT_CANTSUGEPT');
        } else {
          this.detexpmateSelected = this.invexpmaterialesService.detexpmatearray[this.indicador][indi - 1];

          this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
            this.defaultColDef.objeto].setFocusedCell((indi) - 1, 'DETEXPMAT_CANTSUGEPT');
        }

      }

    } catch (error) {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Explosión',
        detail: 'El registro no se eliminó con éxito ' + error
      });
    }

  }
  cambio(evento) {
    if (this.booldetexpmate === true) {
      this.habilitarBotonesBarra(true, false, false, false, false);
    }

  }
  seleccionexpmatemp(params) {
    if (params === 'nuevo') {
      //this.bolNuevodet = true;
      this.nuevodetallemp();
      return;
    }
    if (params === 'guardar') {
      //this.bolNuevodet = true;
      this.guardardetallemp();
      return;
    }
    if (params === 'eliminar') {
      //this.bolNuevodet = true;
      this.eliminardetallemp();
      return;
    }
    if (params.object !== undefined) {
      this.detexpmatempSelected = params.object;
      //console.log(this.detexpmatempSelected)
    }
  }
  async nuevodetallemp(){
    try {
    
    //const indi = this.invexpmaterialesService.trnexpmatmp.indexOf(this.detexpmatempSelected);
    const detexpmate: Trnexpmatmp = {
      ENCEXPMAT_CODIGO: this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO,
      EXPMATMP_CODIGO:'',
      COM_CODIGO:'01',
      EXPMATMP_DESCRIPCION:'',
      EXPMATMP_CANTSUGKG:Number(0).toFixed(this.invexpmaterialesService.decimalesCantidadart),
      NUEVO: true,
      NUEVOL: true,
      LINEA: this.invexpmaterialesService.trnexpmatmp.length + 1
    };
    this.invexpmaterialesService.trnexpmatmp.push(detexpmate);
    this.detexpmatempSelected = detexpmate;
    this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatmp, this.defaultColDefmp.objeto);
    this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
    this.defaultColDefmp.objeto].setFocusedCell(this.invexpmaterialesService.trnexpmatmp.length - 1, 'EXPMATMP_CODIGO');
    } catch (error) {
      
    }
  }
  async eliminardetallemp() {
    try {
      const indi = this.invexpmaterialesService.trnexpmatmp.indexOf(this.detexpmatempSelected);
      if (this.detexpmatempSelected.NUEVOL === true) {
        this.invexpmaterialesService.trnexpmatmp.splice(this.invexpmaterialesService.trnexpmatmp.findIndex(
          detfac => detfac.LINEA === this.detexpmatempSelected.LINEA),
          1);
        this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatmp, this.defaultColDefmp.objeto);

      } else {
        await this.invexpmaterialesService.eliminarlineadetmp(this.detexpmatempSelected)
        await this.auditoriagral.registrarAuditoria('INV_TRNEXPMATMP',
          this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO + '/' + this.detexpmatempSelected.EXPMATMP_CODIGO + '/' + this.detexpmatempSelected.EXPMATMP_CANTSUGKG, 'E', '', '01', '', '', '', '').toPromise();
        this.invexpmaterialesService.trnexpmatmp.splice(this.invexpmaterialesService.trnexpmatmp.findIndex(
          detfac => detfac.LINEA === this.detexpmatempSelected.LINEA),
          1);
        this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatmp, this.defaultColDefmp.objeto);
      }

      this.messageService.add({
        key: 'invexpmate',
        severity: 'success',
        summary: 'Explosión',
        detail: 'El registro se eliminó con éxito '
      });

      if (this.invexpmaterialesService.trnexpmatmp.length > 0) {
        if (indi === 0) {
          this.detexpmatempSelected = this.invexpmaterialesService.trnexpmatmp[indi];

          this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
            this.defaultColDefmp.objeto].setFocusedCell((indi), 'EXPMATMP_CANTSUGKG');
        } else {
          this.detexpmatempSelected = this.invexpmaterialesService.trnexpmatmp[indi - 1];

          this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
            this.defaultColDefmp.objeto].setFocusedCell((indi) - 1, 'EXPMATMP_CANTSUGKG');
        }

      }
    } catch (error) {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Explosión',
        detail: 'El registro no se eliminó con éxito ' + error
      });
    }
  }
  async guardardetallemp() {
    try {
      this.spin = true;
      for (const iterator of this.invexpmaterialesService.trnexpmatmp) {
        if (isNullOrUndefined(iterator.EXPMATMP_CANTSUGKG) || iterator.EXPMATMP_CANTSUGKG === '') {
          this.messageService.add({
            key: 'invexpmate',
            severity: 'error',
            summary: 'Error',
            detail: 'La cantidad sugerida KG no puede estar vacía'
          });
          this.spin = false
          return;
        }
      }
      for (const iterator of this.invexpmaterialesService.trnexpmatmp) {
        if (iterator.NUEVO === true) {
          await this.invexpmaterialesService.guardardetallemp(iterator);
          await this.auditoriagral.registrarAuditoria('INV_TRNEXPMATMP',
            this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO + '/' + iterator.EXPMATMP_CANTSUGKG, 'I', '', '01', '', '', '', '').toPromise();
        } else {
          await this.invexpmaterialesService.actualizardetallemp(iterator);
          await this.auditoriagral.registrarAuditoria('INV_TRNEXPMATMP',
            this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO + '/' + iterator.EXPMATMP_CANTSUGKG, 'A', '', '01', '', '', '', '').toPromise();
        }
      }
      const rs1 = await this.invexpmaterialesService.consultartrnexpmatmp(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO);
      if (rs1.length !== 0 && rs1 !== null) {
        let id = 0
        for (const iterator of rs1) {
          iterator.EXPMATMP_CANTSUGKG = Number(iterator.EXPMATMP_CANTSUGKG).toFixed(this.invexpmaterialesService.decimalesCantidadart)
          iterator.NUEVO = false
          iterator.NUEVOL = false
          iterator.LINEA = id
          id++
        }
        this.invexpmaterialesService.trnexpmatmp = rs1
        this.booldetexpmate = false
        this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatmp, this.defaultColDefmp.objeto);
      }
      this.messageService.add({
        key: 'invexpmate',
        severity: 'success',
        summary: 'Error',
        detail: 'Éxito al guardar los materiales MP '
      });
      this.spin = false;
    } catch (error) {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Explosión',
        detail: 'Ocurrió un error al guardar los materiales MP ' + error
      });
      this.spin = false
    }
  }
  seleccionexpmateac(params) {
    if (params === 'guardar') {
      //this.bolNuevodet = true;
      this.guardardetalleac();
      return;
    }
    if (params === 'eliminar') {
      //this.bolNuevodet = true;
      this.eliminardetalleac();
      return;
    }
    if (params.object !== undefined) {
      this.detexpmateacSelected = params.object;
      //console.log(this.detexpmatempSelected)
    }
  }
  async eliminardetalleac() {
    try {
      const indi = this.invexpmaterialesService.trnexpmatac.indexOf(this.detexpmateacSelected);
      if (this.detexpmateacSelected.NUEVOL === true) {
        this.invexpmaterialesService.trnexpmatac.splice(this.invexpmaterialesService.trnexpmatac.findIndex(
          detfac => detfac.LINEA === this.detexpmateacSelected.LINEA),
          1);
        this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatac, this.defaultColDefac.objeto);
      } else {
        await this.invexpmaterialesService.eliminarlineadetac(this.detexpmateacSelected)
        await this.auditoriagral.registrarAuditoria('INV_TRNEXPMATMP',
          this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO + '/' + this.detexpmateacSelected.TRNEXPMATAC_CODIGO + '/' + this.detexpmateacSelected.TRNEXPMATAC_CANTSUGUND, 'E', '', '01', '', '', '', '').toPromise();
        this.invexpmaterialesService.trnexpmatac.splice(this.invexpmaterialesService.trnexpmatac.findIndex(
          detfac => detfac.LINEA === this.detexpmateacSelected.LINEA),
          1);
        this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatac, this.defaultColDefac.objeto);
      }

      this.messageService.add({
        key: 'invexpmate',
        severity: 'success',
        summary: 'Explosión',
        detail: 'El registro se eliminó con éxito '
      });

      if (this.invexpmaterialesService.trnexpmatac.length > 0) {
        if (indi === 0) {
          this.detexpmateacSelected = this.invexpmaterialesService.trnexpmatac[indi];

          this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
            this.defaultColDefac.objeto].setFocusedCell((indi), 'TRNEXPMATAC_CANTSUGUND');
        } else {
          this.detexpmateacSelected = this.invexpmaterialesService.trnexpmatac[indi - 1];

          this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' +
            this.defaultColDefac.objeto].setFocusedCell((indi) - 1, 'TRNEXPMATAC_CANTSUGUND');
        }

      }
    } catch (error) {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Explosión',
        detail: 'El registro no se eliminó con éxito ' + error
      });
    }
  }
  async guardardetalleac() {
    try {
      this.spin = true;
      for (const iterator of this.invexpmaterialesService.trnexpmatac) {
        if (isNullOrUndefined(iterator.TRNEXPMATAC_CANTSUGUND) || iterator.TRNEXPMATAC_CANTSUGUND === '') {
          this.messageService.add({
            key: 'invexpmate',
            severity: 'error',
            summary: 'Error',
            detail: 'La cantidad sugerida PT no puede estar vacía'
          });
          this.spin = false
          return;
        }
      }
      for (const iterator of this.invexpmaterialesService.trnexpmatac) {
        if (iterator.NUEVO === true) {
          await this.invexpmaterialesService.guardardetalleac(iterator);
          await this.auditoriagral.registrarAuditoria('INV_TRNEXPMATAC',
            this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO + '/' + iterator.TRNEXPMATAC_CODIGO, 'I', '', '01', '', '', '', '').toPromise();
        } else {
          await this.invexpmaterialesService.actualizardetalleac(iterator);
          await this.auditoriagral.registrarAuditoria('INV_TRNEXPMATAC',
            this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO + '/' + iterator.TRNEXPMATAC_CODIGO, 'A', '', '01', '', '', '', '').toPromise();
        }
      }
      const rs1 = await this.invexpmaterialesService.consultartrnexpmatac(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_CODIGO);
      if (rs1.length !== 0 && rs1 !== null) {
        let id = 0
        for (const iterator of rs1) {
          iterator.TRNEXPMATAC_CANTSUGUND = Number(iterator.TRNEXPMATAC_CANTSUGUND).toFixed(this.invexpmaterialesService.decimalesCantidadart)
          iterator.NUEVO = false
          iterator.NUEVOL = false;
          iterator.LINEA = id
          id++
        }
        this.invexpmaterialesService.trnexpmatac = rs1
        this.booldetexpmate = false
        this.aggrid.refreshaggrid(this.invexpmaterialesService.trnexpmatac, this.defaultColDefac.objeto);
      }
      this.messageService.add({
        key: 'invexpmate',
        severity: 'success',
        summary: 'Error',
        detail: 'Éxito al guardar los materiales AC '
      });
      this.spin = false;
    } catch (error) {
      this.messageService.add({
        key: 'invexpmate',
        severity: 'error',
        summary: 'Explosión',
        detail: 'Ocurrió un error al guardar los materiales AC ' + error
      });
      this.spin = false
    }
  }
  cambioDias(event) {
    //console.log(event)
    if (event.checked === true) {
      this.boolfechadesde = false
    } else {
      this.boolfechadesde = true;
    }
    this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_PERIODO = '';
    this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_FECHAINI = '';
  }
  calcularPerdesde(fechaselect: Date) {
    const dateTimeFecIni = new Date(fechaselect);
    const dateTimeFecFin = new Date(this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_FECHAFIN)//

    const diferenciaMs = dateTimeFecFin.getTime() - dateTimeFecIni.getTime();
    console.log(diferenciaMs)
    const dias = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24))
    console.log(dias)
    const periodo = dias / 30;
    console.log(periodo)
    let factor = Math.pow(10, 2);
    let val = Math.round((periodo + Number.EPSILON) * factor) / factor
    val = Number(val.toFixed(2))

    console.log(val)
    this.invexpmaterialesService.encexpmate[this.indicador].ENCEXPMAT_PERIODO = val
  }
  cerrarReportes() {
    this.displayDialogReportes = false;
  }

}
